module.exports = __webpack_public_path__ + "static/media/guest-button.be4e1558.png";